function tableRow(recRowClass){
  const amount = $('#rec-amount').val();
  const cashbookEffect = $('#rec-cashbook-effect option:selected').val();
  const recDescription = $('#rec-description').val();
  const codeId = $('#rec-selected-code option:selected').val();
  const codeName = $('#rec-selected-code option:selected').text();
  const recAction = $('#rec-action option:selected').val();

  return(
    `<tr class=${recRowClass} data-effect_on_cash_book=${cashbookEffect} 
      data-description="${recDescription}" data-code_id=${codeId}
      data-action=${recAction} data-amount="${removeCommas(amount)}">
      <td>${codeName}</td>
      <td class='code-amount text-right'>${numberWithCommas(amount)}</td>
      <td>
        <a href='javascript:;' class='remove-rec-item'>
          <i class='fa fa-minus-circle' style='font-size: 14px; margin-left: 15px; color: red'></i>
        </a>
      </td>
    </tr>`);
}

function getRecSums(recClass){
  // map returns the array of amount while reduces sums
  const sum = $(recClass).map(function(){
    return $(this).data('amount') })
    .get().reduce(function(a, b) { return a + b; }, 0); 

  return sum
}

function setAjustedBalances(){
  const recAmount = removeCommas($('#rec-amount').val());
  const recDescription = $('#rec-description').val();
  const currentBankBalance = removeCommas($('#current-bank-balance').val());

  if (isEmpty(recAmount) ||
    isEmpty(recDescription) || 
    isEmpty(currentBankBalance)){
    
    toastNotification('error','Current Bank Balance, Description and Reconciliation amount must be set');

    return
  }

  const adjustmentType = $('#adjustment-type option:selected').val();
  const recAction = $('#rec-action option:selected').val()

  let recTableId = '#bank-rec-add';
  let recRowClass = 'bank-rec-add'

  if (adjustmentType == 'Cashbook'){
    recTableId = recTableId.replace(/bank/g, 'cash');
    recRowClass = recRowClass.replace(/bank/g, 'cash');
  }

  if (recAction == 'less'){
    recTableId = recTableId.replace(/add/g, 'less');
    recRowClass = recRowClass.replace(/add/g, 'less');
  }

  $(recTableId).append(tableRow(recRowClass));

  adjustBalances();
}

function adjustBalances(){
  const currentBankBalance = removeCommas($('#current-bank-balance').val());
  let adjustedBankBalance = parseFloat(currentBankBalance) + 
    getRecSums('.bank-rec-add') -
    getRecSums('.bank-rec-less');

  const cashbookBalance = $('#adjusted-cashbook-balance-display').data('current-cashbook-balance')
  const adjustedCashBookBalance =  parseFloat(cashbookBalance) +
    getRecSums('.cash-rec-add') -
    getRecSums('.cash-rec-less');

  if (isEmpty(currentBankBalance)){
    adjustedBankBalance = adjustedCashBookBalance
  }
  
  $('#adjusted-bank-balance-display').html(numberWithCommas(adjustedBankBalance));
  $('#adjusted-cashbook-balance-display').html(numberWithCommas(adjustedCashBookBalance));
  $('#adjusted-bank-balance').val(adjustedBankBalance);
  $('#adjusted-cashbook-balance').val(adjustedCashBookBalance);

  setReconciliationValues();
}

function setReconciliationValues(){
  const bankRec = {
    add: $('.bank-rec-add').map(function(){ return $(this).data()}).get(),
    less: $('.bank-rec-less').map(function(){ return $(this).data()}).get()
  }

  const cashbookRec = {
    add: $('.cash-rec-add').map(function(){ return $(this).data()}).get(),
    less: $('.cash-rec-less').map(function(){ return $(this).data()}).get()
  }

  const value = JSON.stringify({
    bank_reconciliation: bankRec,
    cashbook_reconciliation: cashbookRec});

  console.log(value);

  $('#reconciliation-values').val(value)
}

$(document).ready(function() {
  if ($('#reconciliation-form').length > 0){
    adjustBalances();
    
    if ($('.amount-div').length > 0){
      checkAmount('.bank-balance-amount', '.bank-balance-div');
    }

    if ($('.amount-div').length > 0){
      checkAmount('.rec-amount', '.rec-amount-div');
    }

    $('#set-reconciliation').click(function(){
      setAjustedBalances()
    });

    $("table").on('click', '.remove-rec-item', function(e){
      $(e.target).closest('td').closest('tr').remove();
      adjustBalances();
    });
  }

  $('#reconciliation-form').submit(function(e){
    if (isEmpty($('#month-ending').val())){
      toastNotification('error','set date for month ending');
      e.preventDefault();
    }
  })

});
